// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"2":"a8fbe26a","58":"781ed589","67":"c2e812d3","184":"0e49172d","288":"e5e66b1c","421":"3c8661f9","423":"827fed96","430":"cfe65e75","453":"8ab44547","472":"f01ba943","482":"891f1769","573":"75838102","720":"c13e324a","800":"37cafa58","927":"9bf9eed9","967":"eaaa7aec"}[chunkId] + ".chunk.js";
};